import { render } from "./activityDataRecorder.vue?vue&type=template&id=776c3da0&ts=true"
import script from "./activityDataRecorder.vue?vue&type=script&lang=ts"
export * from "./activityDataRecorder.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__